import React, { SyntheticEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { ApplicationState } from 'reducers/';
import { connect } from 'react-redux';
import { Permissions } from '@root/utils/Auth';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from 'api/graphql/mutations';
import { Notification } from '.';
import { ExecutionResult } from "graphql";
import { loginAsUser } from '@api/graphql/types';
import Env from '@root/utils/Env';

interface Props {
    id: string;
    redirect?: string;
    permissions: string[] | null;
}

type PropType = Props & InjectedIntlProps;

class LoginAsUserButton extends React.Component<PropType> {

    private onClick = (e: SyntheticEvent) => {
        GraphQLClient.mutate({
            mutation: Mutations.loginAsUser,
            variables: {
                id: this.props.id,
            },
        }).then((response: ExecutionResult<loginAsUser>) => {
            if (response && response.data && response.data.loginAsUser && response.data.loginAsUser.token) {
                window.open(`${Env.webshopUrl}/token-login/${response.data.loginAsUser.token}${this.props.redirect ? `?redirect=${this.props.redirect}` : ''}`, '_blank');
            } else {
                Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
            }
        });
    }

    public render() {
        if (!this.props.permissions || !this.props.permissions.includes(Permissions.loginAsUser)) {
            return null;
        }

        return (
            <button className="btn btn-primary" onClick={this.onClick}>
                <i className="fa fa-user" /> {this.props.intl.formatMessage({id: 'component.LoginAsUserButton.label'})}
            </button>
        );
    }
}

const mapStateToProps = ({ auth }: ApplicationState) => {
    return {
        permissions: auth.permissions,
    };
};


export default compose(
    injectIntl,
    connect(mapStateToProps),
)(LoginAsUserButton);



// WEBPACK FOOTER //
// ./src/components/LoginAsUserButton.tsx